<script lang="ts">
	import { siteTitle } from '$lib/stores/nav';
	import { onMount } from 'svelte';

	export let data;

	onMount(() => {
		$siteTitle = 'Impressum';
	});
</script>

<div class="mt-4">
	<h1 class="text-4xl mb-10">Impressum</h1>

	<section class="grid lg:grid-cols-[minmax(0,1fr)_minmax(0,4fr)_minmax(0,1fr)] gap-3 py-7">
		<p class="col-span-2">
			Der Internetauftritt crowdsourcing.wien wird Ihnen vom Wien Museum und der Stadt Wien –
			Wienbibliothek im Rathaus gemeinsam zur Verfügung gestellt. Für das
			Transkriptionsprojekt „Briefe {data.project.fromYear}–{data.project.toYear}“ innerhalb
			der Crowdsourcingplattform zeichnet die Stadt Wien – Wienbibliothek im Rathaus
			verantwortlich.
		</p>
	</section>

	<section class="grid lg:grid-cols-[minmax(0,1fr)_minmax(0,4fr)_minmax(0,1fr)] gap-3 py-7">
		<div class="rte lg:col-start-2">
			<p>
				Medieninhaber: Stadt Wien – Wienbibliothek im Rathaus<br />
				Herausgeber: Stadt Wien – Wienbibliothek im Rathaus<br />
				Rathaus, Stiege 6, 1. Stock, 1082 Wien<br />
				Telefon: <a href="tel:+431400084920">+43 (0)1 4000 84920</a>
			</p>
		</div>
	</section>

	<section
		class="grid lg:grid-cols-[minmax(0,1fr)_minmax(0,4fr)_minmax(0,1fr)] gap-3 py-7 border-t"
	>
		<h2>Offenlegung</h2>
		<div class="rte">
			<p>
				„Blattlinie“: crowdsourcing.wien ist eine Plattform, die vom Wien Museum und der
				Stadt Wien – Wienbibliothek im Rathaus für Transkriptionsprojekte zur Verfügung
				gestellt wird. Die Plattform gibt Wienerinnen und Wienern und allen Interessierten
				die Möglichkeit, an der Erschließung des kulturellen Erbes Wiens mitzuwirken, indem
				ausgewählte Bestände der Institutionen öffentlich für Transkriptionsprojekte zur
				Verfügung gestellt werden. Im Projekt „Briefe {data.project.fromYear}–{data.project
					.toYear} werden die digitalisierten Briefe dieser Jahre aus den Beständen der Stadt
				Wien – Wienbibliothek im Rathaus zur Verfügung gestellt. Die transkribierten Texte fließen
				wiederum in das digitale Angebot auf
				<a href="https://digital.wienbibliothek.at" target="_blank" rel="noreferrer"
					>digital.wienbibliothek.at</a
				> ein und verbessern die Suchmöglichkeiten.
			</p>
		</div>
	</section>

	<section
		class="grid lg:grid-cols-[minmax(0,1fr)_minmax(0,4fr)_minmax(0,1fr)] gap-3 py-7 border-t"
	>
		<h2>Design und Programmierung</h2>
		<div class="rte">
			<p>
				<a href="https://bleed.com" target="_blank" rel="noreferrer">Bleed Design Studio</a
				><br />
				<a href="https://urbantrout.io" target="_blank" rel="noreferrer">Urban Trout</a>
				(Harald Atteneder)<br />
				<a href="https://emptygraphics.com/" target="_blank" rel="noreferrer"
					>Empty Graphics</a
				> (Nikolaus Wettstein)
			</p>
		</div>
	</section>

	<section
		class="grid lg:grid-cols-[minmax(0,1fr)_minmax(0,4fr)_minmax(0,1fr)] gap-3 py-7 border-t"
	>
		<h2>Anfragen bitte an:</h2>
		<div class="rte">
			<p>
				<a href="mailto:crowdsourcing@wienbibliothek.at" rel="external"
					>crowdsourcing@wienbibliothek.at</a
				>
			</p>
			<p>
				Alle Ansprechpartner*innen der Wienbibliothek im Rathaus finden Sie hier:
				<a href="https://www.wienbibliothek.at/team">www.wienbibliothek.at/team</a>
			</p>
		</div>
	</section>
</div>
